import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Wysiwyg from "../components/Wysiwyg";
import { ServiceCallToAction } from "../components/CalltoAction";
import { YoastSeo } from "../components/SEO";
import ServiceDetailHeader from "../components/ServiceDetailHeader";
import { RelatedServices } from "../components/Related";
import { SideBar } from "../components/Sidebar";
import { ContentIndex } from "../components/ContentIndex";
import RelatedContent from "../components/Related/RelatedContent";

const ServiceDetail = ({ data }) => {
  const {
    service: {
      content,
      title,
      index,
      serviceCategories,
      seo,
      service: { description, image, relatedServices, relatedCases },
      cta,
    },
    enriseSettings: {
      serviceCtaTitleSmall,
      serviceCtaPhone,
      serviceCtaEmail,
      serviceCtaChatTitle,
      serviceCtaChat,
      serviceCtaContactTitle,
      serviceCtaContact,
      serviceCtaPerson,
    },
  } = data;
  const titleSmall = cta?.ctaTitleSmall || serviceCtaTitleSmall;
  const person = cta?.ctaPerson || serviceCtaPerson;
  const category = serviceCategories?.nodes?.[0];

  return (
    <Layout dark={false} menuShadow>
      <YoastSeo title={title} yoast={seo.fullHead} />
      <ServiceDetailHeader
        type={category?.name}
        title={title}
        description={description}
        image={image || category?.serviceCategory?.image}
      />
      <section className="relative z-20 w-full bg-white md:block">
        <div className="container grid grid-cols-3 gap-x-12 lg:grid-cols-detail">
          <ContentIndex index={index} />
          <main className="col-span-3 py-12 lg:col-span-2 xl:col-span-1 xl:col-start-2">
            <Wysiwyg>{content}</Wysiwyg>
          </main>
          <SideBar
            title={titleSmall}
            image={person?.employee?.image}
            phone={serviceCtaPhone}
            email={serviceCtaEmail}
            chatTitle={serviceCtaChatTitle}
            chat={serviceCtaChat}
            contactTitle={serviceCtaContactTitle}
            contact={serviceCtaContact?.uri}
          />
        </div>
      </section>
      <ServiceCallToAction
        service={title}
        title={cta.ctaTitle}
        person={person}
      />
      <RelatedContent related={relatedCases} />
      <RelatedServices title={title} related={relatedServices} />
    </Layout>
  );
};

export default ServiceDetail;

export const query = graphql`
  query ($id: String!) {
    service: wpService(id: { eq: $id }) {
      title
      content
      index {
        id
        title
      }
      seo {
        fullHead
      }
      serviceCategories {
        nodes {
          name
          serviceCategory {
            image {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(height: 300)
                }
              }
            }
          }
        }
      }
      service {
        description
        image {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(height: 300)
            }
          }
        }
        relatedServices {
          ... on WpService {
            ...ServiceTile
          }
        }
        relatedCases {
          __typename
          ... on WpPost {
            ...PostTile
          }
          ... on WpCase {
            ...CaseTile
          }
        }
      }
      cta {
        ctaTitle
        ctaTitleSmall
        ctaPerson {
          ... on WpEmployee {
            title
            employee {
              phone
              email
              image {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FIXED, width: 230)
                  }
                }
              }
            }
          }
        }
      }
    }
    enriseSettings {
      serviceCtaTitleSmall
      serviceCtaPhone
      serviceCtaEmail
      serviceCtaChatTitle
      serviceCtaChat
      serviceCtaContactTitle
      serviceCtaContact {
        ... on WpUniformResourceIdentifiable {
          uri
        }
      }
      serviceCtaPerson {
        ... on WpEmployee {
          title
          employee {
            phone
            email
            image {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FIXED, width: 230)
                }
              }
            }
          }
        }
      }
    }
  }
`;
